export class SharedControlCrudModel {
    organizationId: number;
    linkedControls: number[];
}